'use client';
import { useEffect, useRef, useState } from "react";
import { FormikProps } from "formik";
import { AddressFormValues, GoogleAutoCompleteResult } from "../ModalClass/types";
import { useAddressBarEvent } from "../hooks/useAddressBarEvent";
import { SessionService } from "../Services/sessionService";
import { addressCheckService } from "../Services/addressCheckService";
import React from "react";
import { Modal } from "./Common/Modal";
import Icon from "./Common/Icon/icon";
import { GoogleAddressAutocompleteNew } from "./Common/GoogleAddressAutocompleteNew";
import WinLoader from "./Common/winLoader/page";

export default function CheckAvailability() {
  const [isLoading, setIsLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [staticMapAddress, setStaticMapAddress] = useState<string>();
  const [isAddressAvailable, setIsAddressAvailable] = useState<boolean>(true);
  const [addressUnit, setAddressUnit] = useState<string>('');
  const [buyToken, setBuyToken] = useState('');
  const [addressData, setAddressData] = useState<string>('');
  const [isAddressSearch, setisAddressSearch] = useState(false);
  const [isProductAvailability, setisProductAvailability] = useState(false);
  const [dfAddressId, setdfAddressId] = useState('');
  const [techType, setTechType] = useState('');
  const [gpid, setGpid] = useState<any>('');
  const [processSteps, setPocessSteps] = useState<string>('addressSearch');
  const [formattedAddress, setFormattedAddress] = useState({
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    postalCode: ''
  });
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const formRef = useRef<FormikProps<AddressFormValues>>(null);

  const buyUri = process.env.REACT_APP_BUYURI;
  // const newbuyUri=process.env.REACT_APP_NEWBUYURI;
  const { setEnteredAddress, setSelectedSuggestion, setAreSuggestionsProvided, trackAddressBarEvent } = useAddressBarEvent();

  const updateWidth = () => {
    setIsMobile(window.innerWidth <= 1023);
  };

  const onClose = () => {
    window.parent.postMessage('closeCANonPopupIframeModal', '*');
    setPocessSteps('addressSearch');
    setIsOpen(false);
    setisAddressSearch(false);
  };

  const onClickAutocomplete = async (addressResult?: GoogleAutoCompleteResult) => {
    if (!addressResult) return;
    setStaticMapAddress(addressResult.address);
    setSelectedSuggestion(addressResult.address);
    setGpid(addressResult.placeId);
    formRef.current?.setFieldValue("address", addressResult.address);
    formRef.current?.setFieldValue("unit", addressResult.unit || '');
    const formattedAddress = formatAddress(addressResult.address);
    if (formattedAddress) {
    setFormattedAddress(formattedAddress);
    }
    setAddressData(addressResult.address);
  };

  const onChangeAddress = async ({ address = "", unit = "" }) => {
    setStaticMapAddress(address);
    setEnteredAddress(address);
    setIsAddressAvailable(!address);
    formRef.current?.setFieldValue("address", address);
    formRef.current?.setFieldValue("unit", unit);
    setAddressData(address);
  };

  const editAddress = () => {
    window.parent.postMessage('closeCANonPopupIframeModal', '*');
    setPocessSteps('addressSearch');
    setIsOpen(false);
    formRef.current?.resetForm();
    setIsAddressAvailable(!staticMapAddress);
    setisAddressSearch(false);
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      console.log(process.env.REACT_APP_API_URL)
      const sessionService = new SessionService();
      try {
        const response = await sessionService.getSession();
        setBuyToken(response?.token || '');
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchAddressData = async () => {
      setIsLoading(true);
      const addressService = new addressCheckService();
      try {
        const response = await addressService.getAddressSearch(buyToken, formattedAddress);
        if (response?.data?.dfAddressId) {
          setdfAddressId(response.data.dfAddressId);
          setTechType(response.data.techType);
          setPocessSteps('serviceAvailable');
        } else {
          setPocessSteps('serviceUnavailable');
        }
        setIsOpen(true);
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    if (isAddressSearch) fetchAddressData();
  }, [buyToken, formattedAddress, isAddressSearch]);

  const handleCALClick = () => {
    setisAddressSearch(true);
  };

  function formatAddress(address: string) {
    const addressRegex = /^(.+?),\s*(.*?),\s*([A-Z]{2})\s*(\d{5}[A-Z]?)$/;
    const match = address.match(addressRegex);

    if (match) {
      const [, addressLine1, city, state, postalCode] = match;
      return {
        addressLine1,
        addressLine2: "", // No address line 2 in this example
        city,
        state,
        postalCode
      };
    } else {
      // Handle the case where the address doesn't match the expected format
      console.error("Address format is incorrect");
      return null;
    }
  }

  const GetPricing = () => {
    console.log(process.env.REACT_APP_BUYURI)
    const queryParams = `?gpid=${gpid}&dfaddressid=${dfAddressId}&appName=standaloneapp`;
    window.open(buyUri + queryParams, '_blank');
  };

  return (
    <div className="twp">
         {isLoading && <WinLoader zIndex="z-40" />}
    
    <div className="pr-3 pl-0">
   
      {processSteps === 'addressSearch' && (
        <div>
          {/* <form className="flex flex-col addressform md:p-3 justify-center items-center w-full">
            <div className="w-full flex items-center space-x-2 mb-4">
              <div className="relative flex-grow max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl">
                <GoogleAddressAutocompleteNew
                  name="address"
                  placeholder="Enter your business address*"
                  onSelectAddress={onClickAutocomplete}
                  onSuggestionsChange={suggestions => setAreSuggestionsProvided(suggestions.length > 0)}
                  onChange={address => onChangeAddress({ address, unit: '' })}
                  value={staticMapAddress}
                  className="w-full text-sm p-2"
                />
              </div>
              <button
                disabled={isAddressAvailable}
                className="flex-shrink-0 w-auto h-[3.25rem] font-bold text-white bg-gradient-to-r from-[#0098b8] to-[#007c83] disabled:bg-[#cac9c8] py-2 px-3 text-xs"
                type="button"
                onClick={handleCALClick}
              >
                Check Availability
              </button>
            </div>
          </form> */}
          <form className="flex flex-col addressform md:p-0 justify-center items-center w-full">
      <div className="w-full flex flex-col md:flex-row md:items-center md:space-x-2 space-y-2 md:space-y-0 mb-4">
      <div className="relative flex-grow max-w-xs sm:max-w-md md:max-w-lg lg:max-w-xl">
      <GoogleAddressAutocompleteNew
        name="address"
        placeholder="Enter your business address*"
        onSelectAddress={onClickAutocomplete}
        onSuggestionsChange={suggestions => setAreSuggestionsProvided(suggestions.length > 0)}
        onChange={address => onChangeAddress({ address, unit: '' })}
        value={staticMapAddress}
        className="w-full text-sm p-2"
      />
    </div>
    <button
      disabled={isAddressAvailable}
      className="flex-shrink-0 w-auto h-[3.25rem] font-bold text-white bg-gradient-to-r from-[#0098b8] to-[#007c83] disabled:bg-[#cac9c8] py-2 px-3 text-xs"
      type="button"
      onClick={handleCALClick}
    >
      Check Availability
    </button>
  </div>
</form>

        </div>
      )}
      <Modal isOpen={isOpen} onRequestClose={onClose} size="sm" className="pb-3 pt-8 serviceModal twp">
        {processSteps === 'serviceAvailable' && (
          <div className="flex-row flex-wrap">
            <div className="address-container flex flex-grow justify-center sm:px-8">
              <Icon iconName="location_on" width={24} height={24} />
              <p className="font-montserrat text-3xs text-[#5a5a5a]">{addressData}</p>
              <button type="button" className="text-[#0098b8] ml-[10px] underline" onClick={editAddress}>
                edit
              </button>
            </div>
            <div className="w-full flex flex-grow justify-center pt-3">
              <div className="w-[649px] font-bold font-dinpro text-center text-cyan-600 text-[28px]">
                {techType?.toUpperCase() === 'FIBER' ? 'Great news, your business is ready for our best Fiber Internet plans' : 'Our fastest Business Broadband Internet is available for your business.'}
              </div>
            </div>
            <div className="w-full flex flex-grow justify-center pt-3 pb-3">
              <div className="w-[467px] text-center text-stone-800 font-montserrat text-base">
                {techType?.toUpperCase() === 'FIBER' ? 'Lightning-fast, worry-free internet with 99.9% reliability and up to 1 Gig upload and download speeds.' : 'Kinetic Business Internet is a reliable, wired internet connection delivered by a fiber-backed network.'}
              </div>
            </div>
            <div className="w-full flex flex-grow justify-center">
              <button className="w-full sm:w-[252px] bg-gradient-to-r from-[#0098b8] to-[#007c83] h-[52px]" onClick={GetPricing}>
                <span className="text-white font-bold text-[14px] uppercase">Get Pricing</span>
              </button>
            </div>
          </div>
        )}
        {processSteps === 'serviceUnavailable' && (
          <div className="flex-row flex-wrap">
            <div className="address-container flex flex-grow justify-center sm:px-8">
              <Icon iconName="location_on" width={24} height={24} />
              <p className="font-montserrat text-3xs text-[#5a5a5a]">{addressData}</p>
              <button type="button" className="text-[#0098b8] ml-[10px] underline" onClick={editAddress}>
                edit
              </button>
            </div>
            <div className="w-full flex flex-grow justify-center pt-3">
              <div className="w-[649px] font-bold font-dinpro text-center text-cyan-600 text-[28px]">
                Thank you for your interest
              </div>
            </div>
            <div className="w-full flex flex-grow justify-center pt-3 pb-3">
              <div className="w-[467px] text-center text-stone-800 font-montserrat text-base">
                We are currently not able to provide business internet at this address. However, please fill out this form to be added to our waiting list and we will let you know once service becomes available.
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
    </div>
  );
}
